<template>
  <div
    class="import-clr-palettes"
    @keydown.enter="apply()"
  >
    <GwInput
      :placeholder="$t('settings.import_colors.placeholder')"
      type="text"
      autofocus
      :getErrors="() => (errors ? [$t('settings.import_colors.error')] : [])"
      :value="inputValue"
      @input="(_e, value) => (inputValue = value)"
      @keydown:enter="apply"
    />
  </div>
</template>

<script>
import { getColorTheme, getStyleTheme } from '@/store/userSettings/colorPalettes'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'ColorPaletteImport',
  components: { GwInput },
  emits: ['success'],
  data() {
    return {
      errors: null,
      inputValue: '',
    }
  },
  methods: {
    apply() {
      const str = this.inputValue
      if (!str) return
      this.errors = null
      let clrs = ''
      let styles = ''
      const stylesStartIndex = str.indexOf(';')
      if (stylesStartIndex === -1) {
        clrs = str
      } else {
        clrs = str.substring(0, stylesStartIndex)
        styles = str.substring(stylesStartIndex + 1)
      }

      clrs = clrs.split(/[ ,]+/)
      styles = styles.split(/[ ,]+/)

      clrs = clrs.map(i => i.trim()).filter(i => i)
      let clrsValid = true

      clrs.forEach(clr => {
        if (
          !/^#([0-9A-F]{6}){1,2}$/i.test(clr) && // no alpha
          !/^#([A-F0-9]{3,4}|[A-F0-9]{6}|[A-F0-9]{8})$/i.test(clr) // with aplha
        ) {
          clrsValid = false
        }
      })
      if (!clrsValid) {
        this.errors = [this.$t('settings.import_colors.error')]
        return
      }

      const settingsStyles = getStyleTheme(styles)
      const settingsColors = getColorTheme(clrs)
      const settings = {
        ...settingsColors,
        ...settingsStyles,
      }
      // console.log(settings)
      this.useSettings(settings)

      this.inputValue = ''
      this.$emit('success')
    },
    useSettings(settings) {
      this.$store.dispatch('userSettings', settings)
      this.$store.dispatch('resetColorSettings')

      this.$store.dispatch('gamestate_repaint_actions', 'ColorPalettes')
      this.$store.getters.hands_namespaces.forEach(nn => {
        this.$store.dispatch(`${nn}/gamestate_repaint_actions`, 'ColorPalettes')
      })

      this.$store.dispatch('messages', {
        type: 'success',
        text: this.$t('messages.theme_updated'),
        hide: true,
      })
      // },
    },
  },
}
</script>

<style lang="scss">
.import-clr-palettes {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
